import { render, staticRenderFns } from "./GiftConfig.vue?vue&type=template&id=2b77ffb8&scoped=true"
import script from "./GiftConfig.vue?vue&type=script&lang=js"
export * from "./GiftConfig.vue?vue&type=script&lang=js"
import style0 from "./GiftConfig.vue?vue&type=style&index=0&id=2b77ffb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77ffb8",
  null
  
)

export default component.exports